import APICaller from '../library/APICaller'

const ContractServices = {
  /**
   * 계약 list
   * @param  {String} params.companyCode 회사코드
   * @param  {String} params.empNo 영업사원 번호
   * @param  {String} params.month 청구월
   * @param  {String} params.searchText 검색어
   * @param  {Number} params.pageNo 검색할 페이지 번호
   * @param  {Number} params.size 페이지당 출력 갯수
   * @return {Promise}
   */
  getContracts ({ companyCode, empNo, month, pageNo, size,searchText ,jobTitleCode,empAuthDept,orderCol, desc, category, startMonth, endMonth }) {
    return APICaller.get('/api/v1/contracts', {
      companyCode, empNo, month, pageNo, size,searchText,jobTitleCode,empAuthDept,orderCol, desc, category, startMonth, endMonth
    })
  },
  /**
   * 계약 상세
   * @param  {companyCode, month, id}
   * @param  {String} params.companyCode 회사코드
   * @param  {String} params.month 청구월 yyyymm
   * @return {Promise}
   */
  getContractsWithId({ companyCode, id, month ,empNo}) {

    return APICaller.get(`/api/v1/contracts/${id}`, {
      companyCode, month,empNo
    })
  },
  /**
   * 계약번호별 청구내역 chart
   * @param  {Object} params 파라미터
   * @param  {String} params.companyCode 회사코드
   * @param  {String} params.empNo 사원번호
   * @param  {String} params.endMonth 청구 종료월
   * @param  {String} params.startMonth 청구 시작월
   * @return {Promise}
   */
  getContractsGetChartDataWithId ({id, companyCode, empNo, endMonth, startMonth }) {
    return APICaller.get(`/api/v1/contracts/${id}/get-chart-data`, {
      companyCode, empNo, endMonth, startMonth
    })
  },
  /**
   * @param  {companyCode, month, id}
   *
   * @param  {Object} params 파라미터
   * @param  {String} params.companyCode 회사코드
   * @param  {String} params.month 청구월
   * @return {Promise}
   */
  getContractsProductsWithId ({ companyCode, id, month }) {
    return APICaller.get(`/api/v1/contracts/${id}/products`, {
      companyCode, month, id
    })
  },
  /**
   * @param  {String} params.companyCode 회사코드
   * @param  {String} params.empNo 사원번호
   * @param  {String} params.endMonth 청구 종료월
   * @param  {String} params.startMonth 청구 시작월
   * @return {Promise}
   */
  getContractsGetChartData ({ companyCode, empNo, endMonth, startMonth ,jobTitleCode,empAuthDept}) {

    return APICaller.get('/api/v1/contracts/get-chart-data', {
      companyCode, empNo, endMonth, startMonth,jobTitleCode,empAuthDept
    })
  },
  /**
   * 고객사별 계약 list
   * @param  {String} params.customerCode
   * @param  {String} params.deptCode
   * @param  {String} params.companyCode
   * @param  {String} params.month
   * @param  {Number} params.pageNo
   * @param  {Number} params.size
   * @return {Promise}
   */
  getCustomersDeptsContactsWithCustomerCodeAndDepthCode ({customerCode, deptCode,  companyCode, month, pageNo, size,orderCol, desc,searchText, category, startMonth, endMonth }) {
    return APICaller.get(`/api/v1/customers/${customerCode}/depts/${deptCode}/contracts`, {
      companyCode, month, pageNo, size, customerCode, deptCode,orderCol, desc,searchText, category, startMonth, endMonth
    })
  },

  getContractsGetCustomerChartData ({ companyCode, empNo, endMonth, startMonth ,customerCode, deptCode}) {

    return APICaller.get(`/api/v1/customers/${customerCode}/depts/${deptCode}/get-chart-data`, {
      companyCode, empNo, endMonth, startMonth,customerCode, deptCode
    })
  },
  getCSPAccountId({companyCode, id, month, prodId}) {
    return APICaller.get(`/api/v1/contracts/${companyCode}/${id}/serviceId/${month}/${prodId}`)
  }

}

export default ContractServices



// WEBPACK FOOTER //
// ./src/services/ContractServices.js